'use strict';

var randItem = require('./array').randItem;

/**
 * Prints a project signature to the console. Pass data from package.json
 * (ie. require('./package.json')) or a custom data object.
 *
 * @param {object} pkgObj - Object, signature: {
 *   name: 'project name',
 *   version: '1.4.1',
 *   description: 'project description',
 *   author: {
 *     name: 'author name',
 *     email: 'author@email.com',
 *     url: 'https://author.url',
 *   },
 * }
 */
var signConsole = function signConsole(_ref) {
  var name = _ref.name,
      version = _ref.version,
      description = _ref.description,
      author = _ref.author;

  var authorTagLines = ['homegrown \uD83C\uDF31 by ' + author.name + ', ' + author.url, 'manufactured with \u2764\uFE0F by ' + author.name + ', ' + author.url, 'magic \uD83E\uDD84 added by ' + author.name + ', ' + author.url, 'report \uD83D\uDC1B to ' + author.email + ' - ' + author.name + ', ' + author.url, 'first seen \uD83C\uDF08 at ' + author.name + ', ' + author.url, 'grown \uD83C\uDF44 by ' + author.name + ', ' + author.url, 'with extra \uD83C\uDF52 flavour added by ' + author.name + ', ' + author.url, 'may contain traces of \uD83E\uDD51 - ' + author.name + ', ' + author.url, author.name + ' \u2764\uFE0F you - ' + author.url];
  console.log('\n\n    ' + name + ' ' + version + '\n    ' + description + '\n    ' + randItem(authorTagLines) + '\n \n ');
};

module.exports = {
  signConsole: signConsole
};